import { styled } from '@volkswagen-onehub/components-core';
import { tokens } from '@/modules/utils/themeUtils';
import { BackgroundVals } from './VehicleToggleButton';
interface VehicleToggleButtonWrapperProps {
  active: boolean;
  stock?: boolean;
  disabled?: boolean;
  background: BackgroundVals;
}

export const VehicleToggleButtonWrapper =
  styled.button<VehicleToggleButtonWrapperProps>(
    ({ theme, active, disabled, background }) => {
      const getBGColour = () => {
        if (background === BackgroundVals.TRANSPARENT) {
          return active
            ? theme.colors.background.primary
            : 'rgba(255, 255, 255, 0.3)';
        }
        return tokens.globalColors.vLightGrey;
      };
      return `
      position: relative;
      border: ${
        background === BackgroundVals.TRANSPARENT
          ? `1px solid ${theme.colors.border.divider}`
          : 'none'
      };
      background-color: ${getBGColour()};
      padding: ${theme.size.static350};
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${theme.size.static150};
      border-radius: ${theme.size.static150};
      border-bottom-width: ${active ? '0px' : '1px'};
      text-decoration: none;
      cursor: pointer;
      pointer-events: ${disabled ? 'none' : 'auto'};

      &:hover {
        border-color: ${theme.colors.border.divider};
      }

      &:focus {
        outline: 0px;
      }
      
      ${
        background === BackgroundVals.TRANSPARENT
          ? `
            transition: background-color .3s ease;
        
            &:hover {
                background-color: ${theme.colors.background.primary};
            }
            `
          : ``
      }
      `;
    }
  );

export const ActiveText = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  
  gap: ${(props) => props.theme.size.static100};

  svg {
    fill: ${theme.colors.button.primary.default};
  }
`);
export const ActiveLine = styled.div(
  ({ theme }) => `
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: ${theme.colors.button.primary.default};
  border-bottom-left-radius: ${theme.size.static150};
  border-bottom-right-radius: ${theme.size.static150};

`
);

export const StockBadgeWrapper = styled.div`
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: max-content;
`;
